var React = require('react');

function LeftArrowIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0817375 1.80885L1.86731 0.0791837C1.9763 -0.0263946 2.1529 -0.0263946 2.26188 0.0791837C2.37086 0.184762 2.37086 0.355844 2.26188 0.461423L0.95267 1.72973L9.72098 1.72973C9.87508 1.72973 10 1.85074 10 2.00003C10 2.14931 9.87508 2.27033 9.72098 2.27033L0.952552 2.27033L2.26176 3.53863C2.37075 3.64421 2.37075 3.81529 2.26176 3.92087C2.20727 3.97366 2.1359 4 2.06454 4C1.99317 4 1.92169 3.97355 1.86731 3.92087L0.0817375 2.19109C-0.0272465 2.08563 -0.0272465 1.91443 0.0817375 1.80885Z","fill":"#D8AE84"}));
}

LeftArrowIcon.defaultProps = {"width":"10","height":"4","viewBox":"0 0 10 4","fill":"none"};

module.exports = LeftArrowIcon;

LeftArrowIcon.default = LeftArrowIcon;



//////////////////
// WEBPACK FOOTER
// /node_modules/svg-react-loader/lib/loader.js?name=LeftArrowIcon!./components/goBack/assets/arrow-left.svg
// module id = YEQi
// module chunks = 0